import React from "react";

const SubscriptionsIntervalLoader = () => {
    return (
        <div className="monthly_yearly_cont">
            <div className="monthly_yearly_choise_loading fade-in"></div>
            <div className="monthly_yearly_choise_loading fade-in"></div>
            <div className="monthly_yearly_choise_loading fade-in"></div>
        </div>
    )
}

export default SubscriptionsIntervalLoader